<div class="favorite-button" [ngClass]="customClass">
  <ng-container *ngIf="(isRegister | async); then activeLikeTemplate else disablelikeTemplate"></ng-container>
  <ng-template #activeLikeTemplate>
    <a a11y_Button matRipple matRippleCentered="true" (click)="!presentationMode && favoriteClick()">
      <div class="inline-icon hypersoft-icon"
        [inlineSVG]="likeStatus ? 'shop-icons.svg#ya-hypersoft-herz-ganz-voll' : 'shop-icons.svg#ya-hypersoft-herz-voll'">
      </div>
    </a>
  </ng-template>
  <ng-template #disablelikeTemplate>
    <div a11y_Button class="disabled-favorite" (click)="!presentationMode && openLoginDialog()">
      <div class="inline-icon hypersoft-icon" inlineSVG="shop-icons.svg#ya-hypersoft-herz-voll"></div>
    </div>
  </ng-template>
</div>